
import { useDispatch, useSelector } from "react-redux";

import TruckData from "./TruckData.js";
import "./Trucks.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

function Trucks(props) {
  const { FirstName } = useSelector((state) => state.auth);
  const { orders } = useSelector((state) => state.data);
  
  // trucks slider settings
  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    nextArrow: orders.length > 5 ? <SamplePrevArrow /> : <></>,
    prevArrow: orders.length > 5 ? <SampleNextArrow /> : <></>,
    focusOnSelect: false,
    initialSlide: orders[0],
    responsive: [
      {
        breakpoint: 1680,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1, 
          dots: false
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div className={"prevArrow" + (props.className.includes("slick-disabled") ? " arrow-disabled" : "")}>
        <FaAngleRight onClick={onClick}/>
      </div>
    );
  }
  
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div className={"nextArrow" + (props.className.includes("slick-disabled") ? " arrow-disabled" : "")}>
        <FaAngleLeft onClick={onClick}/>
        
      </div>
    );
  }


  return (
    orders && orders.length > 1 ? (
      <>
      <div dir="rtl" className={orders.length == 1 ? 'one_order trucks-banner' : 'trucks-banner'}>
        <div className="trucks-row-banner">
          <div className="trucks-note">
            {orders.length > 1 &&
              <span>יש לך {orders.length} רכבים בתהליך אספקה</span>
            }
          </div>
          <div className="slide-wrap">
            {orders.length > 1 &&
                <Slider {...settings}>
                {orders.map((element,key) => (
                  <div>
                    <TruckData truck={element} changeOrder={props.changeOrder}/>
                  </div>
                ))}
              </Slider>
            }
            </div>
          <div className="clear-both"></div>
        </div>
      </div>
      </>
    ) : ''
  );
}

export default Trucks;
